/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { displayMessage, postAPI, getAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import { PlusOutlined, QrcodeOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import {
  Space,
  Button,
  Card,
  Badge,
  Popconfirm,
  Avatar,
  Layout,
  Table,
  Input,
  Tag,
  Result,
} from "antd";
import {
  ALL_QR_SHARING,
  DELETE_QR_SHARING,
  IMAGE_BASE_URL,
} from "../../constants/api";
import LS_SERVICE from "../../utils/localStorage";
import { WHATSAPP_NO } from "../../constants/constent";

function QrSharingTable() {
  const { Content } = Layout;
  const navigate = useNavigate();

  const [state, setState] = useState([]);
  const [filteredState, setFilteredState] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");

  // Module toggle validation: block the screen when the module is disabled.
  const settings = LS_SERVICE.get("setting") || {};
  const moduleEnabled = !!settings.qr_sharing_module_enable;

  useLayoutEffect(() => {
    if (moduleEnabled) {
      getList();
    } else {
      setLoading(false);
    }
  }, []);

  const getList = () => {
    setLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        const formattedData = data["data"].map((row, index) => ({
          key: index,
          ID: index + 1,
          Name: row.title,
          Type: (
            <Tag color={row.type === "ota" ? "blue" : "gold"}>
              {row.type === "ota" ? "OTA" : "Rating"}
            </Tag>
          ),
          TypeRaw: row.type,
          Rating: row.ratting != null ? Number(row.ratting).toFixed(1) : "-",
          Status: (
            <Tag color={row.status ? "green" : "red"}>
              {row.status ? "Active" : "Inactive"}
            </Tag>
          ),
          Image: (
            <Badge>
              <Avatar
                src={row.image ? IMAGE_BASE_URL + row.image.filePath : ""}
                shape="square"
                size="large"
              />
            </Badge>
          ),
          Action: (
            <Space>
              <Button
                onClick={() => navigate("/qr-sharing/edit/" + row.id)}
                block
              >
                Edit
              </Button>
              <Popconfirm
                title="Delete the item"
                description="Are you sure to delete this item?"
                onConfirm={() => deleteData(row.id)}
                okText="Yes"
                cancelText="No"
              >
                <Button danger>Delete</Button>
              </Popconfirm>
            </Space>
          ),
        }));
        setState(formattedData);
        setFilteredState(formattedData);
      } else {
        setState([]);
        setFilteredState([]);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setState([]);
      setFilteredState([]);
      setLoading(false);
    };
    getAPI(ALL_QR_SHARING, successFn, errorFn, {});
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = state.filter((data) =>
      data.Name.toLowerCase().includes(value.toLowerCase()),
    );
    setFilteredState(filtered);
  };

  const deleteData = (id) => {
    setLoading(true);
    const data = { id };
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        getList();
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Delete Data");
    };
    postAPI(DELETE_QR_SHARING, data, successFn, errorFn);
  };

  const columns = [
    { title: "Sno", dataIndex: "ID", width: 50 },
    { title: "Image", dataIndex: "Image", width: 60 },
    { title: "Title", dataIndex: "Name", width: 150 },
    { title: "Type", dataIndex: "Type", width: 80 },
    { title: "Rating", dataIndex: "Rating", width: 70 },
    { title: "Status", dataIndex: "Status", width: 80 },
    { title: "Action", dataIndex: "Action", width: 100 },
  ];

  if (!moduleEnabled) {
    return (
      <Layout>
        <LayoutHeader />
        <Content>
          <Card title="QR Sharing" bordered>
            <Result
              status="warning"
              icon={<QrcodeOutlined />}
              title="QR Sharing module is disabled"
              subTitle="The QR Sharing module is not enabled for your account yet. Please contact your Software Administrator to enable the QR Sharing module and gain access to QR Stickers and the QR Sharing Link."
              extra={
                <Button
                  type="primary"
                  onClick={() => {
                    const phone = WHATSAPP_NO;
                    const message =
                      "Hi, I need help enabling the QR Sharing module for my account. Please assist me with enabling QR Stickers and the QR Sharing Link.";

                    const whatsappUrl = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

                    window.open(whatsappUrl, "_blank");
                  }}
                >
                  Connect on WhatsApp
                </Button>
              }
            />
          </Card>
        </Content>
        <LayoutFooter />
      </Layout>
    );
  }

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Manage QR Sharing"
          extra={
            <Space>
              <Input
                placeholder="Search by Title"
                value={searchText}
                onChange={(e) => handleSearch(e.target.value)}
                style={{ width: 300 }}
              />
              <Button onClick={() => navigate("/qr-sharing/add")}>
                Add <PlusOutlined />
              </Button>
            </Space>
          }
          bordered
        >
          <Table
            loading={loading}
            columns={columns}
            dataSource={filteredState}
            pagination={{ pageSize: 10 }}
            scroll={{ x: 240 }}
          />
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default QrSharingTable;
